/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieUserRegistrationContext,
    JsonSerieUserRegistrationContextFromJSON,
    JsonSerieUserRegistrationContextFromJSONTyped,
    JsonSerieUserRegistrationContextToJSON,
} from './JsonSerieUserRegistrationContext';

/**
 * 
 * @export
 * @interface ApiResultOfJsonSerieUserRegistrationContext
 */
export interface ApiResultOfJsonSerieUserRegistrationContext {
    /**
     * 
     * @type {JsonSerieUserRegistrationContext}
     * @memberof ApiResultOfJsonSerieUserRegistrationContext
     */
    data?: JsonSerieUserRegistrationContext;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserRegistrationContext
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonSerieUserRegistrationContext
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserRegistrationContext
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserRegistrationContext
     */
    result?: ApiResultOfJsonSerieUserRegistrationContextResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonSerieUserRegistrationContextResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonSerieUserRegistrationContextFromJSON(json: any): ApiResultOfJsonSerieUserRegistrationContext {
    return ApiResultOfJsonSerieUserRegistrationContextFromJSONTyped(json, false);
}

export function ApiResultOfJsonSerieUserRegistrationContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonSerieUserRegistrationContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonSerieUserRegistrationContextFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonSerieUserRegistrationContextToJSON(value?: ApiResultOfJsonSerieUserRegistrationContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonSerieUserRegistrationContextToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

